import { WarningOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { unstable_usePrompt } from 'react-router-dom';

import { ScrollVFlex, Space, VFlex } from '@/components/base';
import Quote from '@/components/Quote/Quote';
import useColor from '@/hooks/domain/useColor';

import SettingHeader from '../Header';
import FilterItemsImportingEmailTab from './FilterItemsImportingEmailTab';

const FilterItemsImportingBody = () => {
  const color = useColor();

  const [hasEmailTabChange, setHasEmailTabChange] = useState(false);

  unstable_usePrompt({
    when: hasEmailTabChange,
    message: 'Changes you made may not be saved.',
  });

  return (
    <VFlex height="100vh">
      <SettingHeader title="Filter items: Importing" />
      <ScrollVFlex padding="32px" f={1}>
        <Quote
          themeColor={color.red600}
          icon={<WarningOutlined />}
          title="Note"
          style={{
            fontSize: 12,
            lineHeight: 1.6,
          }}
        >
          <ul style={{ paddingLeft: 24 }}>
            <li>Items on the list will be excluded from importing.</li>
            <li>
              Addition or deletion of items on the list will trigger re-analysis
              of your data which may take a few minutes.
            </li>
          </ul>
        </Quote>

        <Space h={36} />

        <FilterItemsImportingEmailTab
          setHasEmailTabChange={setHasEmailTabChange}
        />
      </ScrollVFlex>
    </VFlex>
  );
};

export default FilterItemsImportingBody;
